import axios from "../../../../utils/request"

function GET_LIST(params) {
    return axios.get("/batch/customer/getInfo", {
        params: {
            ...params
        }
    } )
}
function GET_TABLE_LIST(params) {
    return axios.get("/batch/BatchRecord/record", {
        params: {
            ...params
        }
    } )
}
function GET_IMPORT(params) {
    return axios.get("/batch/fileLib/selects", {
        params: {
            ...params
        }
    } )
}
function GET_NAME(params) {
    return axios.get("/translation/BatchTranslation/customerList", {
        params: {
            ...params
        }
    } )
}

function EDIT_DATA(params) {
    return  axios.post("/batch/customer/getinfo",
        {id:params}
    )
}
function GET_LOAD(params) {
    return axios.get("/batch/FileLib/template", {
        params: {
            ...params
        }
    } )
}
function IMPORT(params) {
    return axios.post("/batch/fileLib/import", {
        params:{...params}
        } )
}
function GET_CLASS(params) {
    return axios.get("/batch/fileLib/downloadCategory", {
        params: {
            ...params
        }
    } )
}
function GET_TEMPLATE(params) {
    return axios.get("/batch/fileLib/templates", {
        params: params
    })
}

// 获取唯一编码
function GET_UNIQUE(params) {
    return axios.get("/batch/FileLib/getUnique", {
        params: params
    })
}
// 上传文件夹
function IMPORT_DIR(params) {
    return axios.post("/batch/FileLib/importDir", {
        ...params
    })
}
function IMPORT_CONFIRM(params) {
    return axios.post("/batch/FileLib/confirm", {
        ...params
    })
}
function IMPORT_CANCEL(params) {
    return axios.post("/batch/BatchRecord/cancel", {
        ...params
    })
}

export default {
    GET_LIST,
    EDIT_DATA,
    GET_IMPORT,
    GET_NAME,
    GET_LOAD,
    IMPORT,
    GET_CLASS,
    GET_TABLE_LIST,
    GET_TEMPLATE,
    GET_UNIQUE,
    IMPORT_DIR,
    IMPORT_CONFIRM,
    IMPORT_CANCEL
}
